import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { PagesService } from 'src/app/pages/services/pages.service';
import { b2bFormField } from './forms/create-b2b-form';
import { updateb2bFormField } from './forms/update-b2b-form';
import { B2bService } from './service/b2b.service';
import { Console } from 'console';
@Component({
	selector: 'app-b2b',
	templateUrl: './b2b.page.html',
	styleUrls: ['./b2b.page.scss'],
})
export class B2bPage implements OnInit {
	currentPagePermission = 'company-b2b';

	getb2bList$: Observable<any> = this.b2bService.fetchb2bData();
	constructor(
		private b2bService: B2bService,
		private router: Router,
		public popoverController: PopoverController,
		public modalController: ModalController,
		public pagesService: PagesService,
	) {
		this.pagesService.notValidPermissionByName(
			this.currentPagePermission,
			'/app/company',
		);
	}

	ngOnInit() {
		this.b2bService.loadb2bInit().subscribe();
		this.b2bService.loadb2bApi().subscribe();
	}
	isCanOpenBox = true;

	viewB2B(id: any) {
		this.router.navigate([`app/company/b2b/${id}/students`]);
	}
	async createb2b() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Create b2b',
					form: b2bFormField,
					onSubmitForm: this.onCreate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
	onCreate(ref: any, editForm: any) {
		return ref.b2bService.addb2b({
			...editForm,
		});
		// return this.faqService.updateFaq(this.jobfairId, editForm.id, editForm);
	}

	async updateb2b(b2b: any, event: any) {
		event.stopPropagation();
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Create b2b',
					form: updateb2bFormField,
					values: b2b,
					isUpdate: true,
					onSubmitForm: this.onUpdate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
	onUpdate(ref: any, editForm: any) {
		return ref.b2bService.updateb2b(editForm.id, {
			...editForm,
		});
	}

	deleteb2b(id: any) {
		console.log(id, 'id');
		this.b2bService.deleteb2b(id).subscribe(() => {
			// this.getJobfairSchedule(this.jobfairId);
		});
	}
	stop(event: any) {
		event.stopPropagation();
	}
}
